import Pako from "pako";

export const comprimirUrl = (token: string) => {
    // Comprime com deflate
    const compressed = Pako.deflate(token);

    // Converte para Base64 URL-safe
    const base64 = btoa(String.fromCharCode(...Array.from(compressed)))
        .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

    return base64
}

export const descomprimirUrl = (token: string) => {
    const decoded = Uint8Array.from(atob(token.replace(/-/g, '+').replace(/_/g, '/')), c => c.charCodeAt(0));
    const original = Pako.inflate(decoded, { to: 'string' });

    return original
}